module.exports = __webpack_public_path__ + "media/images/scansoles-logo-big-1967df20760c5cdbfa9a41418f1298b5.jpg";